import { PropsWithChildren } from "react";
import { DialogContext } from "./DialogContext";

type DialogContextProviderProps = PropsWithChildren<{
  onOpenChange?: (open: boolean) => void;
}>;

export function DialogContextProvider({
  children,
  onOpenChange,
}: DialogContextProviderProps) {
  return (
    <DialogContext.Provider value={{ onOpenChange }}>
      {children}
    </DialogContext.Provider>
  );
}
